import { useEffect } from 'react';
import { useSession } from '../services/queries';
import { sitePalettesSchema } from '@anidex/shared/premium';
import { setPersonalPalettes } from './useTheme';

export function usePersonalPalette() {
  const user = useSession().data?.user;
  const saved = JSON.stringify(user?.premium ? user.sitePalettes ?? null : null);
  useEffect(() => {
    setPersonalPalettes(sitePalettesSchema.nullable().parse(JSON.parse(saved)));
    return () => setPersonalPalettes(null);
  }, [user?.id, saved]);
}
